import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterModule, Routes} from "@angular/router";
import {environment} from "../../environments/environment";
import {FOComponent} from "./fo.component";
import {AccountComponent} from "./account/account.component";
import {SolutionsComponent} from "./page/solutions/solutions.component";
import {LandingProComponent} from "./landing/landing-pro/landing-pro.component";
import {FaqComponent} from "./faq/faq.component";
import {MentionsLegalesComponent} from "./mentions-legales/mentions-legales.component";
import {JoinUsComponent} from "./join-us/join-us.component";
import {CgComponent} from "./cg/cg.component";
import {CguComponent} from "./cgu/cgu.component";
import {ContactComponent} from "./page/contact/contact.component";
import {EventFrameComponent} from "./event-frame/event-frame.component";
import {HomeComponent} from "./home/home.component";
import {EventComponent} from "./event/event.component";
import {EventInscriptionComponent} from "./event-inscription/event-inscription.component";
import {InscriptionEndComponent} from "./event-inscription/inscription-end/inscription-end.component";
import {PaymentSuccessComponent} from "./event-inscription/payment-success/payment-success.component";
import {PaymentConfirmComponent} from "./event-inscription/payment-confirm/payment-confirm.component";
import {BookingComponent} from "./booking/booking.component";
import {BookingInfosComponent} from "./booking/booking-infos/booking-infos.component";
import {BookingHousingComponent} from "./booking/booking-housing/booking-housing.component";
import {BookingPaymentComponent} from "./booking/booking-payment/booking-payment.component";
import {BookingDeadlinePaymentComponent} from "./booking/booking-deadline-payment/booking-deadline-payment.component";
import {BookingConfirmComponent} from "./booking/booking-confirm/booking-confirm.component";
import {CategoriesComponent} from "./home/categories/categories.component";
import {LinksComponent} from "./links/links.component";
import {HandleTokenComponent} from "./handle-token/handle-token.component";
import {UserGuard} from "../core/guards/user.guard";



let FO_BASE_ROUTING: Routes = (environment.pro == true) ?
  [
    { path: '', redirectTo:'/landing/pro', pathMatch: 'full'},
    { path: '', component: FOComponent,
      children: [
        { path: 'account', component: AccountComponent },
        { path: 'solutions', component: SolutionsComponent },
        { path: 'landing/pro', component: LandingProComponent },
        { path: 'faq', component: FaqComponent },
        { path: 'mentions-legales', component: MentionsLegalesComponent },
        { path: 'join-us', component: JoinUsComponent },
        { path: 'cg', component: CgComponent },
        { path: 'cgu', component: CguComponent },
        { path: 'contact', component: ContactComponent }
      ]
    },
    { path: 'handletoken/:token', component: HandleTokenComponent },
  ] :
  [
    { path: 'event-frame/:name/:id',component: EventFrameComponent,runGuardsAndResolvers: 'always'},
    { path: '', redirectTo:'/home', pathMatch: 'full' },
    { path: '', component: FOComponent,
      children: [
        { path: 'faq', component: FaqComponent },
        { path: 'mentions-legales', component: MentionsLegalesComponent },
        { path: 'join-us', component: JoinUsComponent },
        { path: 'cg', component: CgComponent },
        { path: 'cgu', component: CguComponent },
        { path: 'home', component: HomeComponent },// boris
        { path: 'event/:name/:id',
          component: EventComponent,
          data: {
            title: 'About',
            metatags: {
              'og:description': `your description here`,
              'twitter:description': `your description`,
              keywords: `your keywords here`
            }
          }
        },
        { path: 'eventandhousing/:name/:id',component: EventInscriptionComponent,runGuardsAndResolvers: 'always'},
        { path: 'inscriptions/:name/:inscriptionId',component: EventInscriptionComponent,runGuardsAndResolvers: 'always'},
        { path: 'inscriptionvalidation/:name/:inscriptionId',component: EventInscriptionComponent,runGuardsAndResolvers: 'always'},
        { path: 'inscriptionend', component: InscriptionEndComponent},
        { path: 'inscription/payment/success', component: PaymentSuccessComponent},
        { path: 'inscription/confirm', component: PaymentConfirmComponent},
        { path: 'eventchild/:name/:id',component: EventComponent,runGuardsAndResolvers: 'always'},//yuman
        { path: 'event/:id', component: EventComponent},
        { path: 'booking', component: BookingComponent, children: [ // phareal
            { path: 'infos', component: BookingInfosComponent},
            { path: 'housing', component: BookingHousingComponent},//yuman
            { path: 'payment', component: BookingPaymentComponent}, //yuman
            { path: 'paymentdealine', component: BookingDeadlinePaymentComponent}, //yuman
            //{ path: 'confirmation', component: BookingConfirmComponent },
            { path: 'payment/success', component: BookingConfirmComponent},
            { path:  'payment/cancel', component: BookingConfirmComponent},// phareal
          ]}, //yuman
        { path: 'landing/pro', component: LandingProComponent},
        { path: 'account', component: AccountComponent },
        { path: 'tickets', component: AccountComponent },
        { path: 'contact', component: ContactComponent },
        { path: ':categorie', component: CategoriesComponent},
        { path: 'l/links', component: LinksComponent}
      ]
    }
  ];

let routes: Routes = (environment.iframe == true)?
  [
    { path: '', redirectTo:'/home', pathMatch: 'full' },
    { path: '', component: FOComponent,
      children: [
        { path: 'eventandhousing/:name/:id',component: EventInscriptionComponent,runGuardsAndResolvers: 'always'},
        { path: 'booking', component: BookingComponent,children: [
            { path: 'infos', component: BookingInfosComponent},
            { path: 'housing', component: BookingHousingComponent},
            { path: 'payment', component: BookingPaymentComponent},
            { path: 'paymentdealine', component: BookingDeadlinePaymentComponent},
            { path: 'payment/success', component: BookingConfirmComponent},
            { path:  'payment/cancel', component: BookingConfirmComponent},
          ]}, //yuman
      ]
    }
  ] : FO_BASE_ROUTING;

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forChild(routes),
    CommonModule
  ]
})
export class FoRoutingModule { }
